import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import 'numeral/locales/it';
import { inject } from 'mobx-react';
import PrimaryButton from '../../shared_components/buttons/PrimaryButtonComponent';
import ShowComponent from '../../hocs/ShowComponent';


@ShowComponent
class SavingsComponent extends React.Component {

  render() {
    const { advisorSearchUrl } = this.props.ToolSettingData;

    const {
      showPdfDownloadButton,
      textDownloadReport,
      startDownloadPdf,
    } = this.props;

    let saving = '';

    if (_.some(this.props.series[1].data, (item => item > 0))) {
      saving = numeral(this.props.series[0].data[1]).format('$ 0,00');
    }

    return (
      <div className={this.props.classNames}>
        <h2>Uw besparing met looptijdrente</h2>
        <div className="savings-container__total-saving">
          {saving},-
        </div>

        <div className="savings-container__button-group">
          <PrimaryButton
            show={showPdfDownloadButton}
            onClickHandler={startDownloadPdf}
            disabled={!_.isEmpty(textDownloadReport)}
            href="#"
            text={textDownloadReport || 'Download rapport'}
          />

          <PrimaryButton
            onClickHandler={() => { window.open(advisorSearchUrl, '_blank'); }}
            classNames="search-button"
            text="Zoek adviseur"
            show={!_.isEmpty(advisorSearchUrl)}
          />
        </div>

      </div>
    );
  }
}

SavingsComponent.propTypes = {
  series: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.array,
  ]),
  ToolSettingData: PropTypes.shape({
    advisorSearchUrl: PropTypes.string,
  }),
  showPdfDownloadButton: PropTypes.bool,
  textDownloadReport: PropTypes.string,
  startDownloadPdf: PropTypes.func,
  classNames: PropTypes.string,
};

SavingsComponent.defaultProps = {
  series: {},
  ToolSettingData: {},
  classNames: '',
  showPdfDownloadButton: false,
  textDownloadReport: '',
  startDownloadPdf: '',
};

export default inject('ToolSettingData')(SavingsComponent);
